import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, map, Observable, tap } from 'rxjs'
import { NdisNumberDto } from 'src/app/models/client/ndis-number-dto'
import { ApplicationInsightsService } from '../application-insights/application-insights.service'
import { ConfigService } from '../config/config.service'

// Story e8-2: a separate backend controller/service, not folded onto ClientService/ClientDto —
// resolving the NDIS number can call PracSuite and conditionally create a tsc_ndisplan record, so
// only the Service Plan Stepper calls this, right after loading client details (see
// service-plan-stepper.component.ts's loadClient()) — not every client-scoped screen.
@Injectable({
  providedIn: 'root',
})
export class NdisPlanService {
  private readonly ndisNumberUrl =
    this.config.getSettings('webApi').baseUri + 'ndisplan/number'

  constructor(
    private http: HttpClient,
    private appInsights: ApplicationInsightsService,
    private config: ConfigService,
  ) {}

  GetNdisNumber(contactId: string): Observable<NdisNumberDto> {
    const params: Record<string, string> = { contactId: contactId }

    return this.http
      .get<NdisNumberDto>(this.ndisNumberUrl, { params: params })
      .pipe(
        map((response) => response as NdisNumberDto),
        tap((_) => this.appInsights.logEvent('Retrieved NDIS number')),
        catchError(async (err) => {
          throw err
        }),
      )
  }
}
